<span nz-dropdown [nzDropdownMenu]="menu" nzOverlayClassName="ui-dropdown-menu-overlay">
  <ng-content></ng-content>
</span>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu nzSelectable>
    @for(item of menus; track $index){
    <li
      nz-menu-item
      [nzSelected]="selectedIndex === $index"
      (click)="onMenuSelected(item)"
      aria-hidden="true"
    >
      @if (iconField !== null) {
      <div class="flex flex-row justify-between gap-3">
        <ui-icon [name]="getIconName(item)" size="22px"></ui-icon>
        {{ item[textField] }}
      </div>
      } @else {
      {{ item[textField] }}
      }
    </li>
    }
  </ul>
</nz-dropdown-menu>
